import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ModuleLayout from "../../layout/ModuleLayout";
import { useTranslation } from "react-i18next";
import { FaHandHoldingUsd, FaCalendarAlt, FaListAlt } from "react-icons/fa";
import RecouvrementCalendarPage from "../Recouverement/RecouvrementCalendarPage";
import RecouvrementListPage from "../Recouverement/RecouvrementListPage";


const RecouvrementModule = () => {
  const { t } = useTranslation();

  const moduleConfig = {
    id: "recouvrement",
    title: t("modules.recouvrement.title"),
    description: t("modules.recouvrement.description"),
    icon: FaHandHoldingUsd,
    color: "#0d6efd",
    menuItems: [
      {
        path: "/recouvrement-module/calendar",
        icon: FaCalendarAlt,
        label: t("nav.recouvrementCalendar"),
      },
      {
        path: "/recouvrement-module/list",
        icon: FaListAlt,
        label: t("nav.recouvrementList"),
      },
    ],
  };

  return (
    <ModuleLayout moduleConfig={moduleConfig}>
      <Routes>
        {/* default */}
        <Route path="/" element={<Navigate to="/recouvrement-module/calendar" replace />} />

        {/* routes */}
        <Route path="/calendar" element={<RecouvrementCalendarPage />} />
        <Route path="/list" element={<RecouvrementListPage />} />
      </Routes>
    </ModuleLayout>
  );
};

export default RecouvrementModule;